// import defaultSetting from "@/setting"
//导航
export const navList = []

//首页轮播
const banner01 = require("@/assets/images/banner/banner01.jpg")
const banner02 = require("@/assets/images/banner/banner02.jpg")
const banner03 = require("@/assets/images/banner/banner03.jpg")
const banner04 = require("@/assets/images/banner/banner04.png")
const banner05 = require("@/assets/images/banner/banner05.jpg")
const banner06 = require("@/assets/images/banner/banner06.jpg")
const banner07 = require("@/assets/images/banner/banner07.png")
export const swiperList = [
  {
    imgUrl: banner01,
    toUrl: "#",
  },
  {
    imgUrl: banner02,
    toUrl: "#",
  },
  {
    imgUrl: banner03,
    toUrl: "#",
  },
  {
    imgUrl: banner04,
    toUrl: "#",
  },
  {
    imgUrl: banner05,
    toUrl: "#",
  },
  {
    imgUrl: banner06,
    toUrl: "#",
  },
  {
    imgUrl: banner07,
    toUrl: "#",
  },
]

// 品牌图片
const brand2 = require("@/assets/images/brand/logo2.png")
// const brand02 = require("@/assets/images/brand/logo02.png")
const brand3 = require("@/assets/images/brand/logo3.png")
const brand03 = require("@/assets/images/brand/logo03.png")
const brand4 = require("@/assets/images/brand/logo4.png")
const brand5 = require("@/assets/images/brand/logo5.png")
const brand6 = require("@/assets/images/brand/logo6.png")
const brand7 = require("@/assets/images/brand/logo7.png")
const brand8 = require("@/assets/images/brand/logo8.png")
const brand9 = require("@/assets/images/brand/logo9.png")
const brand10 = require("@/assets/images/brand/logo10.png")
const brand11 = require("@/assets/images/brand/logo11.png")
// const brand12 = require("@/assets/images/brand/logo12.png")
const brand13 = require("@/assets/images/brand/logo13.png")

export const brandList = [
  [
    [
      {
        id: 2,
        // imgUrl: brand02,
        // title: "一汽旗偲",
        imgUrl: brand5,
        title: "一汽股权",
        toUrl: "/detail",
      },
      {
        id: 22,
        imgUrl: brand5,
        title: "财务公司",
        toUrl: "/detail",
      },
      {
        id: 5,
        imgUrl: brand5,
        title: "一汽资本控股",
        toUrl: "/detail",
      },
      {
        id: 4,
        imgUrl: brand2,
        title: "一汽红旗",
        toUrl: "/detail",
      },
    ],
    [
      {
        id: 3,
        imgUrl: brand03,
        title: "一汽出行",
        toUrl: "/detail",
      },
      {
        id: 8,
        imgUrl: brand5,
        title: "一汽富华",
        toUrl: "/detail",
      },
      {
        id: 7,
        imgUrl: brand4,
        title: "一汽奔腾",
        toUrl: "/detail",
      },
    ],
    [
      // {
      //   id: 17,
      //   imgUrl: brand10,
      //   title: "长春检测中心",
      //   toUrl: "/detail",
      // },
      {
        id: 23,
        imgUrl: brand5,
        title: "旗新动力",
        toUrl: "/detail",
      },
      {
        id: 21,
        imgUrl: brand13,
        title: "中汽新能",
        toUrl: "/detail",
      },
      // {
      //   id: 9,
      //   imgUrl: brand5,
      //   title: "一汽资产",
      //   toUrl: "/detail",
      // },

    ],
  ],
  [
    [
      {
        id: 11,
        imgUrl: brand7,
        title: "一汽解放",
        toUrl: "/detail",
      },
      {
        id: 13,
        imgUrl: brand5,
        title: "一汽铸锻",
        toUrl: "/detail",
      },
      {
        id: 14,
        imgUrl: brand8,
        title: "一汽模具",
        toUrl: "/detail",
      },
      {
        id: 16,
        imgUrl: brand5,
        title: "能源公司",
        toUrl: "/detail",
      },
      // {
      //   id: 12,
      //   imgUrl: brand5,
      //   title: "一汽物流",
      //   toUrl: "/detail",
      // },
    ],
    [
      {
        id: 15,
        imgUrl: brand9,
        title: "一汽-大众",
        toUrl: "/detail",
      },
      {
        id: 10,
        imgUrl: brand6,
        title: "一汽丰田",
        toUrl: "/detail",
      },
      {
        id: 18,
        imgUrl: brand11,
        title: "奥迪一汽",
        toUrl: "/detail",
      },
    ],
    [
      // {
      //   id: 19,
      //   imgUrl: brand5,
      //   title: "华东试验场",
      //   toUrl: "/detail",
      // },
      // {
      //   id: 20,
      //   imgUrl: brand12,
      //   title: "机械九院",
      //   toUrl: "/detail",
      // },
      {
        id: 1,
        imgUrl: brand5,
        title: "一汽进出口",
        toUrl: "/detail",
      },
      {
        id: 6,
        imgUrl: brand3,
        title: "启明信息",
        toUrl: "/detail",
      },
    ],
  ],
]

// 为什么选择中国一汽？
export const lifeList = [
  {
    id: 1,
    title: "汽车产业 时代先锋",
    content: "中国一汽主动顺应全球新一轮科技革命大势，以打造世界一流汽车企业为愿景，牢记习近平总书记视察一汽时的隐隐嘱托，以“SUCCEED（成事）531”规划纲要为战略牵引，聚焦高质量发展主线，矢志不渝地为新中国汽车产业作出共和国“长子”的贡献。",
  },
  {
    id: 2,
    title: "员工发展 命运共同",
    content: "始终坚持把人才作为企业的第一核心资源，全面打造中国一汽事业发展与员工成长命运共同体。擎实才强、才强业兴，擎才奋进、人企共赢，为培育世界一流顶尖人才提供高效的人才政策保障，为打造世界一流汽车企业提供坚实的先锋人才队伍。",
  },
  {
    id: 3,
    title: "优质理念 激发活力",
    content: "践行“勇立潮头、永争第一、奋斗奋进、干事成事”的企业精神，通过机制建设与不断创新，使有潜力的人才得到发展、有业绩的人才得到重用，形成人人想干事、人人能干事、人人干成事的氛围。",
  },
]

//完善的薪酬福利
export const youngList = [
  {
    id: 1,
    title: "薪酬保险 多重补贴",
    content: "优越的薪酬体系\n完善的六险二金\n安家补贴\n采暖补贴、通讯补贴、节假日补贴、单身补贴",
  },
  {
    id: 2,
    title: "体贴入微 关怀备至",
    content: "衣食住行（四季工装、工作餐、职工公寓、通勤班车）\n工会福利、节日福利、生日福利\n健康体检",
  },
  {
    id: 3,
    title: "特色福利 幸福加倍",
    content: "厂休假、探亲假、带薪年假\n购车优惠",
  },
]
//faw group
const social1 = require("@/assets/images/social/s01@2x.jpg")
const social2 = require("@/assets/images/social/s02@2x.jpg")
const social3 = require("@/assets/images/social/s03@2x.jpg")

// 解忧杂货
export const groceriesList = [
  [
    {
      id: 1,
      title: "志趣相投聚一堂",
      content: "志同道合的新朋友\n相见恨晚 快速破冰",
    },
    {
      id: 2,
      title: "身份角色快转变",
      content: "新员工入职培训\n助你快速胜任职位",
    },
    {
      id: 3,
      title: "轻松融入新圈子",
      content: "大学生欢迎仪式\n红旗嘉年华\n马拉松比赛\n趣味运动会\n丰富的工会活动",
    },
  ],
  [
    {
      id: 1,
      title: "不断更新的知识系统",
      content: "海量内部学习资源\n成为你踏入行业的稳健脚步",
    },
    {
      id: 2,
      title: "行业一流大咖带路",
      content: "业界大咖导师赋能\n高人指点 助你快速成长",
    },
    {
      id: 3,
      title: "支撑你的职场“长期主义”",
      content: "因材施教的丰富培训项目\n多种职业发展路径\n让你自己选择未来的赛道",
    },
  ],
  [
    {
      id: 1,
      title: "舒适环境，让工作更舒心",
      content: "宽敞明亮 环境恒温\n会议设施 智能交互",
    },
    {
      id: 2,
      title: "休闲放松，找回更好状态",
      content: "咖啡馆 休息区 健身房\n足球场 篮球场 医务室\n让你保持身心满电",
    },
    {
      id: 3,
      title: "家人共享的美妙时光",
      content: "单身联谊会\n集体婚礼\n家属开放日\n将充实和快乐分享给全家",
    },
  ],
]

export const groupList = [
  {
    id: 1,
    imgUrl: social3,
    toUrl: `/positionList?recruitType=2&projectId=205202`,
    target: "_self",
    title: "高端领军人才",
    // content: '中国第一汽车集团有限公司（以下简称中国一汽）是国有特大型汽车企业集团。不讲 title 和层级，敢于授权新人，专注完成业务目标，没有领地意识'
  },
  {
    id: 2,
    imgUrl: social2,
    toUrl: `/positionList?recruitType=2&projectId=205201`,
    target: "_self",
    title: "社会成熟人才",
    // content: '累计产销汽车超过5000万辆，销量规模位列中国汽车行业第一阵营。'
  },
  {
    id: 3,
    imgUrl: social1,
    toUrl: "https://www.hotjob.cn/wt/FAW/ir/web/login",
    target: "_self",
    title: "员工内部推荐",
    // content: '中国第一汽车集团有限公司（以下简称中国一汽）是国有特大型汽车企业集团。'
  },
]
